module.exports = __webpack_public_path__ + "img/files.5dc5dd97.svg";